export default {"src":"/_next/static/media/WhatsApp.d002efd2.svg","height":60,"width":60};